import React, { useState, useEffect } from 'react';
import { useParams, useLocation, useNavigate } from 'react-router-dom';
import { ArrowLeft, Pencil, User, Calendar, Book, Award, CheckCircle, BookOpen, Trash } from 'lucide-react';

// Importe o seu formulário de edição
// import FormAluno from './FormAluno'; 

// Importa a folha de estilos exclusiva desta view
import './professores.css';
import ProfessorAdd from './ProfessorAdd';
import { useAuth } from '../../../hooks/AuthContext';
import { getDocumentoUnico, removerProfessorCompleto } from '../../../firebase/CRUD';

export default function AlunosView() {

    const location = useLocation();

    const [AlunoInfo, setAlunoInfo] = useState({});
    // const [aluno, setAluno] = useState(location?.state || [])
    const [cadastramento, setCadastramento] = useState(false);
    const [historico, setHistorico] = useState({ biblias: 0, revistas: 0, pontos: 0, presencas: 0 });
    
    const { id } = useParams();
    const navigate = useNavigate();
    
    // Obtém o aluno passado através da navegação
    const {usuario} = useAuth()

    useEffect(() => {
        const dados = (aluno)=>{
            if (aluno && aluno.historico) {

                let hist = {
                    biblias: aluno.historico.biblias?.reduce((acc, val) => acc + val, 0) || 0,
                    revistas: aluno.historico.revista?.reduce((acc, val) => acc + val, 0) || 0,
                    pontos: aluno.historico.pontos?.reduce((acc, val) => acc + val, 0) || 0,
                    presencas: aluno.historico.presenca?.reduce((acc, val) => acc + val, 0) || 0,
                };
                setHistorico(hist);
                setAlunoInfo(aluno);
            } 
        }
        
        getDocumentoUnico('professores',id,dados,usuario.idEscola)
    }, [cadastramento]);

    const ativarCadastramento = () => setCadastramento(true);
    const desativarCadastramento = () => setCadastramento(false);

    // Funções auxiliares para a UI
    const getInicial = (nome) => nome ? nome.charAt(0).toUpperCase() : '?';
    const formatarGenero = (gen) => gen === 'F' ? 'Feminino' : gen === 'M' ? 'Masculino' : gen;

    const deletarCadastro = async ()=>{ 
        const uid = AlunoInfo.uid
        if (window.confirm("Tem certeza que deseja excluir este usuário permanentemente?")) {
            try {
                // CORREÇÃO: antes era só `deleteItem('professores', id, ...)`
                // (apagava a ficha, mas a pessoa continuava logando, com
                // acesso total às turmas). `removerProfessorCompleto` cuida
                // de Auth + usuarios/{uid} + membros/{uid} em todas as
                // turmas + a ficha de professor, nessa ordem seguindem
                // (Cloud Function primeiro — se ela negar por permissão,
                // nada mais é apagado).
                await removerProfessorCompleto(usuario.idEscola, id, uid);
                alert("Usuário excluído com sucesso!");
            } catch (error) {
                alert("Erro ao excluir: " + error.message);
            }
            navigate(-1,{replace:true})
        }; 
    }

    return (
        <div className="view-container">
            {cadastramento && <ProfessorAdd edit={AlunoInfo} cadastramento={desativarCadastramento}/>}
            {/* --- CABEÇALHO DO PERFIL --- */}
            <div className="perfil_Header">
                <div className="top-actions">
                    <button className="icon-btn" title="Voltar" onClick={() => navigate(-1)}>
                        <ArrowLeft size={22} strokeWidth={2.5} />
                    </button>
                    <div style={{display:'flex',gap:'10px'}}>
                        <button className="icon-btn" onClick={ativarCadastramento} title="Editar Ficha">
                            <Pencil size={20} strokeWidth={2.5} />
                        </button>
                        <button className='icon-btn'
                        title='Escluir registro'
                        onClick={deletarCadastro}
                        >
                            <Trash size={20} strokeWidth={2.5}/>
                        </button>
                    </div>
                </div>
                
                <div className="perfil-info">
                    <div className="avatar">
                        {getInicial(AlunoInfo.nome)}
                    </div>
                    <h2 className="aluno-nome">{AlunoInfo.nome || 'A carregar...'}</h2>
                    <span className="aluno-turma">Turma - {AlunoInfo.turmaNome || 'Sem Turma'}</span>
                </div>
            </div>

            {/* --- CORPO DA FICHA --- */}
            <div className="perfil-content">
                
                {/* DADOS PESSOAIS (CARD) */}
                <div className="data-card">
                    <h3 className="card-title">Dados Pessoais</h3>
                    <div className="info-list">
                        <div className="info-item">
                            <div className="info-icon"><User size={22} strokeWidth={2.5} /></div>
                            <div className="info-text">
                                <label>Gênero</label>
                                <span>{formatarGenero(AlunoInfo.genero) || "Não informado"}</span>
                            </div>
                        </div>
                        <div className="info-item">
                            <div className="info-icon"><Calendar size={22} strokeWidth={2.5} /></div>
                            <div className="info-text">
                                <label>Data de Nascimento</label>
                                <span>{AlunoInfo.dataNascimento || "Não informada"}</span>
                            </div>
                        </div>
                    </div>
                </div>

                {/* DESEMPENHO EBD (GRID DE KPIs) */}
                <div className="data-card">
                    <h3 className="card-title">Desempenho na EBD</h3>
                    <div className="stats-grid">
                        <div className="stat-box">
                            <CheckCircle size={32} className="stat-icon" style={{color: '#10b981'}} strokeWidth={2} />
                            <span className="stat-value">{historico.presencas}</span>
                            <span className="stat-label">Presenças</span>
                        </div>
                        <div className="stat-box">
                            <BookOpen size={32} className="stat-icon" style={{color: '#4c00ff'}} strokeWidth={2} />
                            <span className="stat-value">{historico.revistas}</span>
                            <span className="stat-label">Revistas</span>
                        </div>
                        <div className="stat-box">
                            <Book size={32} className="stat-icon" style={{color: '#f59e0b'}} strokeWidth={2} />
                            <span className="stat-value">{historico.biblias}</span>
                            <span className="stat-label">Bíblias</span>
                        </div>
                        <div className="stat-box">
                            <Award size={32} className="stat-icon" style={{color: '#f43f5e'}} strokeWidth={2} />
                            <span className="stat-value">{historico.pontos}</span>
                            <span className="stat-label">Pontos Acum.</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}